"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddMembersContext = exports.ADD_USER_TYPE = void 0;
const react_1 = require("react");
var ADD_USER_TYPE;
(function (ADD_USER_TYPE) {
    ADD_USER_TYPE["REFERRAL"] = "referral";
    ADD_USER_TYPE["USER"] = "add";
    ADD_USER_TYPE["GROUP"] = "group";
})(ADD_USER_TYPE || (exports.ADD_USER_TYPE = ADD_USER_TYPE = {}));
exports.AddMembersContext = (0, react_1.createContext)({});
